import { Box, useTheme } from '@mui/material'
import { SparkLineChart } from '@mui/x-charts/SparkLineChart'
import { c100Tokens } from './c100-tokens'

export default function SparkCell({ values }: { values: number[] }) {
  const theme = useTheme()
  const t = c100Tokens(theme)

  if (!values || values.length < 2) {
    return (
      <Box
        sx={{
          width: 110,
          height: 34,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: 1,
            bgcolor: t.hairline
          }}
        />
      </Box>
    )
  }

  const isUp = values[values.length - 1] >= values[0]
  const color = isUp ? t.gain : t.loss

  return (
    <Box sx={{ width: 110, height: 34 }}>
      <SparkLineChart
        data={values}
        height={34}
        width={110}
        curve="natural"
        colors={[color]}
        showHighlight={false}
        showTooltip={false}
        area
        sx={{
          '& .MuiAreaElement-root': {
            fillOpacity: 0.12
          },
          '& .MuiLineElement-root': {
            strokeWidth: 1.5
          }
        }}
      />
    </Box>
  )
}
